module.exports = __webpack_public_path__ + "static/img/textarea.6a19873e.svg";